export interface CarouselDimensions {
  mainCardImage: { width: number; height: number };
  cardGap: number;
}

/** Design sizes in px, measured against the 1440px design width. */
export const CAROUSEL_DIMENSIONS: CarouselDimensions = {
  mainCardImage: { width: 277, height: 492 },
  cardGap: 16,
};
